import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';
import { HttpErrorResponse, NotificationType, SignalRNotificationType } from '../../types';

const getNotifications = createAction('NOTIFICATIONS_GET');
const getNotificationsRequest = createAsyncAction(
  'NOTIFICATIONS_GET_REQUEST',
  'NOTIFICATIONS_GET_SUCCESS',
  'NOTIFICATIONS_GET_REJECTED'
)<undefined, NotificationType[], HttpErrorResponse>();

const addNotification = createAction(
  'NOTIFICATION_ADD',
  (action) => (notification: SignalRNotificationType) => action(notification)
);

const markNotificationAsRead = createAction('NOTIFICATION_MARK_READ', (action) => (id: string) => action(id));
const markAllNotificationsAsRead = createAction('NOTIFICATION_MARK_ALL_READ');

const markNotificationAsReadRequest = createAsyncAction(
  'NOTIFICATION_MARK_READ_REQUEST',
  'NOTIFICATION_MARK_READ_SUCCESS',
  'NOTIFICATION_MARK_READ_REJECTED'
)<undefined, NotificationType, HttpErrorResponse>();

const markAllNotificationsAsReadRequest = createAsyncAction(
  'NOTIFICATION_MARK_ALL_READ_REQUEST',
  'NOTIFICATION_MARK_ALL_READ_SUCCESS',
  'NOTIFICATION_MARK_ALL_READ_REJECTED'
)<undefined, undefined, HttpErrorResponse>();

export const notificationActions = {
  getNotifications,
  getNotificationsRequest,
  addNotification,
  markNotificationAsRead,
  markNotificationAsReadRequest,
  markAllNotificationsAsRead,
  markAllNotificationsAsReadRequest,
};
export type NotificationActions = ActionType<typeof notificationActions>;
